import { render, staticRenderFns } from "./ConfirmResetPassword.vue?vue&type=template&id=2f0e0736"
import script from "./ConfirmResetPassword.vue?vue&type=script&lang=ts"
export * from "./ConfirmResetPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports